const state = {
  navItems: [
    { name: "clothing", hasSubNav: true },
    { name: "shoes", hasSubNav: true },
    { name: "accessories", hasSubNav: true },
    { name: "brands", hasSubNav: false },
    { name: "stores", hasSubNav: false },
    { name: "sale", highlighted: true, hasSubNav: true }
  ],
  currentNavItem: null,
  currentSubNavItem: null
};

const getters = {
  getNavItems: () => state.navItems,
  getNavItemsMobile: () => {
    const arr = [...state.navItems];
    const temp = state.navItems[5];
    arr.splice(5, 1);
    arr.splice(3, 0, temp);
    return arr;
  },
  getCurrentNavItem: () => state.currentNavItem,
  getCurrentSubNavItem: () => state.currentSubNavItem
};

const actions = {};
``;
const mutations = {
  setCurrentNavItem(state, payload) {
    state.currentNavItem = payload;
  },
  setCurrentSubNavItem(state, payload) {
    state.currentSubNavItem = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
